export default function parseCategories(groups) {
  let categories = groups && JSON.parse(JSON.stringify(groups));

  let strollers = categories?.find(item => item.name === 'Vankrid').children;

  if (strollers) {
    const sets = strollers?.find(item => item.name === 'Komplektid');
    const secureSets = strollers?.find(
      item => item.name === 'Komplektid koos turvahälliga'
    );

    const indexOfSets = strollers?.indexOf(sets);
    const indexOfSecureSets = strollers?.indexOf(secureSets);

    delete strollers[indexOfSecureSets];
    strollers?.push(strollers?.splice(indexOfSets, 1).pop());
  }

  return categories;
}
